// Scripts librairies
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

// model Like
function getModelLike (btn) {
  import(/* webpackChunkName: "modelLike" */ './js/components/modelLike.js').then(module => {
    module.modelLike.init(btn)
    document.getElementById('likeModel').click()
  })
}

docReady(function () {
  // gestion des filtres depuis la navbar
  const $mn = document.getElementById('sub-nav')
  const $h = document.getElementById('header')
  const openHeader = function () {
    if ($mn) {
      const stickyEl = $mn.closest('.sticky-top')
      if ($h.querySelector('.navbar-collapse').classList.contains('show')) {
        stickyEl.style.zIndex = '999'
      } else {
        stickyEl.style.zIndex = '1020'
      }
    }
  }
  $h.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openHeader)
  $h.querySelector('.navbar-close').addEventListener('click', openHeader)
  if ($mn && $mn.querySelector('.navbar-toggler[data-trigger]')) {
    const openSubnav = function () {
      const stickyEl = $mn.closest('.sticky-top')
      if ($mn.querySelector('.navbar-collapse').classList.contains('show')) {
        stickyEl.style.zIndex = '1020'
      } else {
        stickyEl.style.zIndex = '999'
      }
    }
    $mn.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openSubnav)
    $mn.querySelector('.navbar-close').addEventListener('click', openSubnav)
  }

  // gestion des likes
  const btn = document.getElementById('likeModel')
  if (btn) {
    btn.addEventListener('click', () => {
      getModelLike(btn)
    })
  }

  // auto-anchor
  const target = document.querySelector('[data-anchor="auto"]')
  if (target) {
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth' })
    }, 800)
  }

  // boutons d'action sur le modèle détaillé
  const financingBtn = document.getElementById('track-f')
  if (financingBtn) {
    financingBtn.addEventListener('click', () => {
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'financing_model') }
    })
  }
  const contactBtn = document.getElementById('track-c')
  if (contactBtn) {
    contactBtn.addEventListener('click', () => {
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact_model') }
    })
  }
  const groundBtn = document.getElementById('track-g')
  if (groundBtn) {
    groundBtn.addEventListener('click', () => {
      if (typeof (googletag) !== 'undefined') { gtag('event', 'ground_search') }
    })
  }
})
